/**
 * CaptaZap - homologacao Meta desativada na interface operacional.
 * Mantem exportacao compativel com CaptaZap.jsx, sem exibir botao ou painel.
 * A desativacao visual nao altera rotas, credenciais nem a integracao Meta.
 */
export default function MetaHomologacaoViewer() {
  return null;
}
